import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../../http.service';
import { DocumentGridComponent } from '../document-grid/document-grid.component';
import { FormPopupModule } from '../../../components/library/form-popup/form-popup.component';
import { DxBoxModule, DxButtonModule, DxScrollViewModule } from 'devextreme-angular';
import { ApproveComponent } from '../approve/approve.component';
import { DeclineComponent } from '../decline/decline.component';
import { RequestAdditionalInfoComponent } from '../request-additional-info/request-additional-info.component';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [DocumentGridComponent,
    FormPopupModule,
    DxBoxModule,
    ApproveComponent,
    DeclineComponent,
    RequestAdditionalInfoComponent,
    DxButtonModule,
    CommonModule,
    DxScrollViewModule],
  selector: 'app-merchant-validation',
  templateUrl: './merchant-validation.component.html',
  styleUrl: './merchant-validation.component.scss'
})
export class MerchantValidationComponent {

  data: any;

  isSelectSuperMerchantPopupOpened: boolean = false;
  isApprovedMerchantPopupOpened: boolean = false;
  isRequestAdditionalInfoPopupOpened: boolean = false;
  isDeclinedMerchantPopupOpened: boolean = false;
  merchantId: number = 0;
  constructor(private route: ActivatedRoute, private httpService: HttpService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      this.merchantId = params['id'];
      this.httpService.getMerchantById(id).subscribe(res => {
        this.data = res;
        console.log('data', this.data)
      })
    });
  }



}
